module.exports = __webpack_public_path__ + "static/media/apartment3.90a1be40.png";